import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  index() {
    const url = apiRoutes.apiV1ChatsPath();

    return FetchHelpers.get(url);
  },

  show(uid) {
    const url = apiRoutes.apiV1ChatPath(uid);

    return FetchHelpers.get(url);
  },
  update(uid, attributes) {
    const url = apiRoutes.apiV1ChatPath(uid);

    return FetchHelpers.put(url, attributes);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/ChatRepository.js